const { default: AuthorFormPage } = require("./AuthorFormPage")

const AuthorCreate = () => {
  return (
    <AuthorFormPage></AuthorFormPage>
  )
}

export default AuthorCreate